import { type ThemeOptions, type Theme } from '@mui/material';

export function createDialogStyles() {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme }: { theme: Theme }) => ({
          variants: [
            {
              props: (props) => !props['square'] && !props['fullScreen'],
              style: {
                borderRadius: `${theme.shape.borderRadiusLg}px`,
              },
            },
          ],
        }),
      },
    },
  } as ThemeOptions['components'];
}
